import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { investmentDurationOptions2 } from '@app/forms/subscription/services/ref';

@Component({
    selector: 'investment-period',
    templateUrl: './investment-period.component.html',
    styleUrls: ['./investment-period.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class InvestmentPeriodComponent implements OnInit {
  @Input() derrors = false;
  options: FormControlOption[] = investmentDurationOptions2;
  constructor() {}

  ngOnInit() {}
}
